<life-di-nav></life-di-nav>
<!-- <div class="displayChart">
  <div id="entire"> -->
<div *ngIf="role">
  <div *ngIf="paymentcomplete && report">
    <div *ngIf="report.data2.length === 0" id="chart">
      <div *ngIf="type === 'profile'">
        <lifedi-report-profile [measureid]="mid" [type]="paid" [view_status]="view_status"
          [access_id]="access_id"  [informant_type]="informant_type"></lifedi-report-profile>
      </div>
      <div *ngIf="type === 'profile_matching'">
        <lifedi-report-matching [measureid]="mid" [type]="paid" [view_status]="view_status"
          [access_id]="access_id"  [informant_type]="informant_type"></lifedi-report-matching>
      </div>
      <div *ngIf="type === 'spider'">
        <lifedi-report-spider [measureid]="mid" [type]="paid" [view_status]="view_status"
          [access_id]="access_id"  [informant_type]="informant_type"></lifedi-report-spider>
      </div>
      <div *ngIf="type === 'standard'">
        <lifedi-report-standard [measureid]="mid" [type]="paid" [view_status]="view_status"
          [access_id]="access_id"  [informant_type]="informant_type"></lifedi-report-standard>
      </div>
      <div *ngIf="type === '4box'">
        <lifedi-report-boxchart [measureid]="mid" [type]="paid" [view_status]="view_status"
          [access_id]="access_id"  [informant_type]="informant_type"></lifedi-report-boxchart>
      </div>
      <div *ngIf="type === 'toprank'">
        <lifedi-report-top-rank [measureid]="mid" [type]="paid" [view_status]="view_status"
          [access_id]="access_id"  [informant_type]="informant_type"></lifedi-report-top-rank>
      </div>
    </div>


    <div *ngIf="report.data2.length > 0" id="informant-chart">
      <div *ngIf="type === 'profile'">
        <lifedi-profile-informant [measureid]="mid" [type]="paid" [view_status]="view_status"
          [access_id]="access_id"  [informant_type]="informant_type"></lifedi-profile-informant>
      </div>
      <div *ngIf="type === 'spider'">
        <lifedi-spider-informant [measureid]="mid" [type]="paid" [view_status]="view_status"
          [access_id]="access_id"  [informant_type]="informant_type"></lifedi-spider-informant>
      </div>
      <div *ngIf="type === 'standard'">
        <lifedi-standard-informant [measureid]="mid" [type]="paid" [view_status]="view_status"
          [access_id]="access_id"  [informant_type]="informant_type"></lifedi-standard-informant>
      </div>
      <div *ngIf="type === '4box'">
        <lifedi-box-chart-informant [measureid]="mid" [type]="paid" [view_status]="view_status"
          [access_id]="access_id"  [informant_type]="informant_type"></lifedi-box-chart-informant>
      </div>
      <div *ngIf="type === 'profile_matching'">
        <lifedi-matching-informant [measureid]="mid" [type]="paid" [view_status]="view_status"
          [access_id]="access_id"  [informant_type]="informant_type"></lifedi-matching-informant>
      </div>
      <div *ngIf="type === 'toprank'">
        <lifedi-top-rank-informant [measureid]="mid" [type]="paid" [view_status]="view_status"
          [access_id]="access_id"  [informant_type]="informant_type"></lifedi-top-rank-informant>
      </div>
    </div>
  </div>
</div>
<div class="containter">
  <div *ngIf="!role" class="login">
    <h3>กรุณาเข้าสู่ระบบ</h3>
    <lifedi-btn lable="เข้าสู่ระบบ" (click)="openLogin()" customStyle="background: #414A6B; color: #FFFFFF; margin-top: 0px;
            padding: 0 25px;">
    </lifedi-btn>
  </div>
</div>
<!-- <div *ngIf="paymentcomplete ===false?notcomplete():''">
</div> -->